<template>
	<label class="checkbox-toggle">
		<span :class="['fake-label', disabled ? 'disabled' : '']" v-if="checkboxLabel">{{ checkboxLabel }}</span>
		<div v-if="disabled">
			<input type="checkbox" :disabled="disabled" v-model="value" @change="changeHandler" :id="id">
			<span class="fake-input disabled"></span>
		</div>
		<div v-else>
			<input type="checkbox" v-model="value" @change="changeHandler" :id="id">
			<span class="fake-input "></span>
		</div>
	</label>
</template>

<script>
export default {
	name: 'VCheckboxToggle',
	props: {
		page: {},
		checkboxLabel: {},
		model: {},
		id: {},
		disabled: {}
	},
	data() {
		return {
			value: this.model
		}
	},
	methods: {
		changeHandler() {
			this.$emit('changeHandler', this.value)
		}
	}
}
</script>

<style lang="scss">
.checkbox-toggle {
	display: inline-flex;
	align-items: center;

	input[type="checkbox"],
	input[type="radio"] {
		position: fixed;
		left: 1;
		top: 0;
		opacity: 0;
		z-index: -1;

		&:checked {
			+ .fake-input {
				background-color: $blue-hover;
				border: 0.5px solid rgba(0, 0, 0, 0.12);

				&:after {
					background-color: #ffff;
					left: calc(100% - 22px);
				}
			}

			+ .fake-input.disabled {
				&:after {
					background: #3C3C432E;
					cursor: alias;
					left: 1px;
				}
			}
		}
	}

	.fake-input {
		width: 40px;
		height: 24px;
		border-radius: 2em;
		display: block;
		cursor: pointer;
		position: relative;
		border: 0.5px solid rgba(0, 0, 0, 0.12);
		background: #AEAEAE;
		transition: background-color .3s;

		&:after {
			content: '';
			position: absolute;
			top: 50%;
			left: 1px;
			transform: translateY(-50%);
			background-color: #fff;
			border-radius: 50%;
			width: 21px;
    	height: 21px;
			transition: left .3s;
		}
	}

}
.fake-label {
	cursor: pointer;
	font-weight: 500;
	color: #fff;

	&.disabled {
		color: $gray-3;
		cursor: alias;
	}
}
</style>
